export function isMissingMockError(error: Error): boolean {
  return (
    Boolean(global.__NODE_TESTING__) && error.message.startsWith('No more mocked responses for the query')
  );
}

export function shouldLogMissingMockError(): boolean {
  return (
    Boolean(global.__NODE_TESTING__) &&
    ['true', '1'].includes((process.env.ENABLE_MISSING_GQL_MOCK_LOGS || '').toLowerCase())
  );
}
